import { NavLink } from "react-router-dom";
import ImgLinkBtn from "./ImgLinkBtn";

interface ProjectProps {
  projectType: String;
  name: String;
  date: String;
  description: String;
  image: string;
  toolsUsed: string;
  writeupUrl?: string;
  githubUrl?: string;
}

const Project: React.FC<ProjectProps> = (props: ProjectProps) => {
  return (
    <div className="flex flex-col lg:flex-row">
      <div className="m-3 flex flex-col lg:aspect-video lg:w-3/5">
        <img className="w-max h-auto max-h-[500px]" src={props.image} alt="missingImg" />
      </div>
      <div className="m-3 flex flex-col gap-2 lg:w-1/3">
        <div className="font-thin lg:m-0">
          <p className="projectType"> {props.projectType} </p>
          <p className="projectDate">{props.date}</p>
        </div>
        <h2 className="projectTitle font-bold">{props.name}</h2>
        <p className="projectDescription">{props.description}</p>
        <p className="font-extralight"> Tools used : {props.toolsUsed}</p>
        <div className="flex gap-4">
          {props.writeupUrl ? (
            <NavLink to={"/" + props.writeupUrl}>
              <p className="text-red underline">View Writeup</p>
            </NavLink>
          ) : (
            <em className="text-red">Writeup coming soon!</em>
          )}
          {props.githubUrl && (
            <a href={props.githubUrl}>
              <p className="text-red underline">Github</p>
            </a>
          )}
        </div>
      </div>
    </div>
  )
}

export default Project;
